export const SET_PAGE="SET_PAGE";
export const SET_IMPACT_SECTION_DATA = "SET_IMPACT_SECTION_DATA";
export const SET_HEADER_TYPE = "SET_HEADER_TYPE";
export const SET_EMAIL = "SET_EMAIL";
export const SET_LOADER = "SET_LOADER";
